export const validatePhone = (phone?: string) =>
  !!phone && `${phone}`.trim().length > 6;
